module.exports = __webpack_public_path__ + "img/logo.1ae73cb7.jpg";